export default function trim(str) {
  return String.prototype.trim.call(str || '')
}
